import { Button, Col, Row } from "react-bootstrap";
import styles from '../../../../styles/incidents.module.css';
import FloatingActionButton from "../../../../components/floatingactionbutton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useGetIncidents } from "../../../../new/query";
import { useNavigate, useParams } from "react-router-dom";

export const IncidentStage = {
    Initial: 0, Followup: 1,FollowupStaff: 2, ResponseToFollowup: 3
}

const IncidentsList = () => {
    const {medicaidid} = useParams();

    const safeMedicaidId = encodeURIComponent(medicaidid);
    
    const navigate = useNavigate();

    const incidentQuery = useGetIncidents(medicaidid);

    if(incidentQuery.isLoading) return <div>loading...</div>

    return(
        <Row>
            <Col xs={12}>
                <Row>
                    <Col xs={12}>
                        <div className={styles.incidentListHeader}>
                            <h3>Incidents</h3>
                            <FloatingActionButton aria-label="Add Incident" type="button" variant="success" onClick={() => navigate(`/Client/Client/${safeMedicaidId}/incidents/add`)}>
                                <FloatingActionButton.Icon>
                                    <FontAwesomeIcon icon={faPlus} size="lg" />
                                </FloatingActionButton.Icon>
                                <FloatingActionButton.Text>
                                    Add Incident
                                </FloatingActionButton.Text>
                            </FloatingActionButton>
                        </div>
                    </Col>
                </Row>
            </Col>
            <Col xs={12}>
                <Row className={styles.incidentListBody}>
                    {
                        incidentQuery.data.map((item) => (
                            <Col xs={12} md={6} lg={4} xl={3} className="mb-4 " key={item.id}>
                                <div className='clientCard'>
                                    <div>
                                        <h5 className={styles.incidentCardHeader}>
                                            {item.classification}
                                        </h5>
                                        <div className={styles.incidentCardBody}>
                                            <div className="mb-1">
                                                <h6 className="mb-0">Incident Type</h6>
                                                <p className="mb-0">{item.incidentType === null ? "N/A" : item.incidentType}</p>
                                            </div>
                                            <div className="mb-1">
                                                <h6 className="mb-0">Incident Date & Time</h6>
                                                <p className="mb-0">{item.incidentDateTime}</p>
                                            </div>
                                            <div className="mb-1">
                                                <h6 className="mb-0">Reporting Agency</h6>
                                                <p className="mb-0">{item.reportingAgency === null ? "N/A" : item.reportingAgency}</p>
                                            </div>
                                            <div className="mb-1 d-flex justify-content-end">
                                                <Button type="button" className="me-1" variant="primary" onClick={() => navigate(`/Client/Client/${safeMedicaidId}/incidents/${item.id}`)}>Edit</Button>
                                                <Button type="button" variant="danger">Delete</Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))
                    }
                </Row>
            </Col>
        </Row>
    )
}

export default IncidentsList;